/**
 * キャンペーン名から運用者コードとメニューを読み取る。
 * 読み方は契約ごとに違うので、規則を外から渡せる形にしてある。
 */

export type Platform = 'meta' | 'tiktok' | 'google'

export interface NamingRules {
  /** 運用者コードを拾う正規表現。1つ目の括弧がコード。上から順に試す。 */
  operatorPatterns: string[]
  /** メニューの接頭辞（長い物から照合する）と、その表示名。 */
  menuPrefixes: Record<string, string>
}

export const DEFAULT_NAMING: NamingRules = {
  operatorPatterns: ['^[a-z]+_([a-z]+)_', '_([a-z]{2,3})_m\\d'],
  menuPrefixes: {
    tcyob: 'tcyob',
    tcho: 'ホクロ',
    tcha: '鼻整形',
    tcc: 'クマ取り',
    tcp: 'ピコ',
    tcn: 'ニキビ',
    tch: 'ヒアル',
    tc: '二重',
  },
}

/**
 * 運用者コードを読む。正規表現で拾えなければ、既知のコードが `_コード_` の形で
 * 含まれているかを最後に見る（現行と同じ順番）。
 */
export function operatorFromCampaignName(
  name: string | null | undefined,
  knownCodes: string[] = [],
  rules: NamingRules = DEFAULT_NAMING,
): string {
  if (!name) return ''
  const lower = name.toLowerCase()
  for (const src of rules.operatorPatterns) {
    let re: RegExp
    try {
      re = new RegExp(src)
    } catch {
      continue
    }
    const m = lower.match(re)
    if (m?.[1]) return m[1]
  }
  for (const code of knownCodes) {
    if (lower.includes(`_${code}_`)) return code
  }
  return ''
}

export function menuPrefix(
  name: string | null | undefined,
  menu: string | null | undefined,
  rules: NamingRules = DEFAULT_NAMING,
): string | null {
  const hay = `${name || ''} ${menu || ''}`.toLowerCase()
  const prefixes = Object.keys(rules.menuPrefixes).sort((a, b) => b.length - a.length)
  for (const p of prefixes) {
    if (new RegExp(`(^|[^a-z])${p}_`).test(hay)) return p
  }
  return null
}

/** 媒体は名前からしか分からないことがある。 */
export function resolvePlatform(
  campaignName?: string | null,
  platform?: string | null,
  accountName?: string | null,
): Platform {
  const p = (platform || '').toLowerCase()
  if (p.includes('tiktok')) return 'tiktok'
  if (p.includes('google')) return 'google'
  if (p.includes('meta') || p.includes('facebook')) return 'meta'
  const tik = /(^|[_\W])(tik|tiktok)([_\W]|$)/
  if (tik.test((campaignName || '').toLowerCase()) || tik.test((accountName || '').toLowerCase())) {
    return 'tiktok'
  }
  return 'meta'
}
